<template>
    <div id="hello">
        <NavBarTherapist v-if="isTherapist"/>
        <NavBar v-else/>
        <TherapistSchedule v-if="isTherapist"/>
        <PatientSchedule v-else-if="isTherapistSelected"/>
        <impersonating-nav-bar v-if="canImpersonate"></impersonating-nav-bar>
    </div>
</template>

<script>
import PatientSchedule from "@/components/PatientSchedule";
import TherapistSchedule from "@/components/TherapistSchedule";
import NavBarTherapist from "@/components/auth/NavBarTherapist";
import NavBar from "@/components/auth/NavBar";
import ImpersonatingNavBar from "@/components/ImpersonatingNavBar.vue";

export default {
    components: {
        NavBar,
        NavBarTherapist,
        PatientSchedule,
        TherapistSchedule,
        ImpersonatingNavBar,
    },
    data() {
        return {
            userRoles: this.$store.getters.userRoles
        }
    },
    computed: {
        isTherapist() {
            //console.log(this.userRoles);
            return this.userRoles.includes("ROLE_THERAPIST");
        },
        isTherapistSelected() {
            return this.$store.getters.isTherapistSelected;
        },
        canImpersonate() {
            return this.userRoles.includes("ROLE_IMPERSONATE");
        },
    }
};
</script>
